import { render, staticRenderFns } from "./NeoparentCreatePost.vue?vue&type=template&id=973a6602&scoped=true"
import script from "./NeoparentCreatePost.vue?vue&type=script&lang=js"
export * from "./NeoparentCreatePost.vue?vue&type=script&lang=js"
import style0 from "./NeoparentCreatePost.vue?vue&type=style&index=0&id=973a6602&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973a6602",
  null
  
)

export default component.exports